export const STATISTIC_NAMESPACE = "statistic";

const STATISTIC_CONFIGS = {
  walk: {
    default: () => ({}),
    fnSuffix: "Walk",
  },
  heartbeat: {
    default: () => ({}),
    fnSuffix: "Heartbeat",
  },
  sleep: {
    default: () => ({}),
    fnSuffix: "Sleep",
  },
  talk: {
    default: () => ({}),
    fnSuffix: "Talk",
  },
  skinTemp: {
    default: () => ({}),
    fnSuffix: "SkinTemp",
  },
  speed: {
    default: () => ({}),
    fnSuffix: "Speed",
  },
  metsh: {
    default: () => ({}),
    fnSuffix: "Metsh",
  },
  pitch: {
    default: () => ({}),
    fnSuffix: "Pitch",
  },
  kcal: {
    default: () => ({}),
    fnSuffix: "Kcal",
  },
};

export const getSetStatisticFunctions = () => {
  return Object.entries(STATISTIC_CONFIGS).reduce(
    (acc, [feedbackKey, config]) => {
      acc.push(getSetStatisticFunctionName(config));
      return acc;
    },
    []
  );
};

const getSetStatisticFunctionName = (config) => {
  return `setStatistic${config.fnSuffix}`;
};

const generateCommonFunctions = () => {
  return Object.entries(STATISTIC_CONFIGS).reduce(
    (acc, [feedbackKey, config]) => {
      const setFunctionName = getSetStatisticFunctionName(config);
      const removeFunctionName = `removeStatistic${config.fnSuffix}`;

      acc[setFunctionName] = function (state, { key, value }) {
        this.commit(`${STATISTIC_NAMESPACE}/setStatisticData`, {
          feedbackKey,
          key,
          value,
        });
      };

      acc[removeFunctionName] = function () {
        this.commit(`${STATISTIC_NAMESPACE}/removeStatisticData`, {
          feedbackKey,
        });
      };
      return acc;
    },
    {}
  );
};

const getStatisticDataDefault = () => {
  return Object.entries(STATISTIC_CONFIGS).reduce(
    (acc, [feedbackKey, config]) => {
      acc[feedbackKey] = config.default();
      return acc;
    },
    {}
  );
};

export default {
  namespaced: true,
  state: {
    statisticData: getStatisticDataDefault(),
  },
  mutations: {
    setStatisticData(state, { feedbackKey, key, value }) {
      state.statisticData[feedbackKey][key] = value;
    },
    removeStatisticData(state, { feedbackKey }) {
      state.statisticData[feedbackKey] = {};
    },
    ...generateCommonFunctions(),
  },
};
